import OperatorLanguageSelector from '@/shared/components/LanguageSelector'

export default function AppFooter() {
  return (
    <footer className="sm:left-64 bottom-0 left-0 bg-white p-4 mt-auto">
      <div className="flex justify-between items-center">
        <div className="text-xs -l80 font-medium">
          <p>© {new Date().getFullYear()} Artem Technologie AG</p>
        </div>
        <OperatorLanguageSelector showLabel />
      </div>
    </footer>
  )
}
